import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component"],
  _excluded2 = ["component"];
import { Fragment } from 'react';
import cn from 'classnames';
import getDefaultIconPropValues from "../helpers/getDefaultIconPropValues";
import ResponsiveText from "../ResponsiveText";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonWithLabelChildren = function ButtonWithLabelChildren(_ref) {
  var label = _ref.label,
    leftIconProp = _ref.leftIcon,
    rightIconProp = _ref.rightIcon,
    defaultIconSize = _ref.defaultIconSize,
    children = _ref.children;
  var _getDefaultIconPropVa = getDefaultIconPropValues(leftIconProp, defaultIconSize || 24),
    LeftIcon = _getDefaultIconPropVa.component,
    leftIcon = _objectWithoutProperties(_getDefaultIconPropVa, _excluded);
  var _getDefaultIconPropVa2 = getDefaultIconPropValues(rightIconProp, defaultIconSize || 24),
    RightIcon = _getDefaultIconPropVa2.component,
    rightIcon = _objectWithoutProperties(_getDefaultIconPropVa2, _excluded2);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [LeftIcon && /*#__PURE__*/_jsx(LeftIcon, {
      size: leftIcon.size,
      className: cn({
        'fill-current': leftIcon.hasFill,
        'stroke-current': leftIcon.hasStroke,
        'mr-8': label || children
      }, 'flex-shrink-0'),
      ignoreColor: true
    }), label ? /*#__PURE__*/_jsx(ResponsiveText, {
      text: label
    }) : children, RightIcon && /*#__PURE__*/_jsx(RightIcon, {
      size: rightIcon.size,
      className: cn({
        'fill-current': rightIcon.hasFill,
        'stroke-current': rightIcon.hasStroke,
        'ml-8': label || children
      }, 'flex-shrink-0'),
      ignoreColor: true
    })]
  });
};
export default ButtonWithLabelChildren;